import posthog, { PostHog } from "posthog-js"

export const posthogClient = posthog.init(
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  {
    api_host: import.meta.env.VITE_PUBLIC_REVERSE_PROXY_POSTHOG_DOMAIN,
    ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    capture_pageview: false,
    capture_exceptions: true,
    loaded: (ph) => {
      const posthogEnabled = import.meta.env.VITE_POSTHOG_ENABLED === `true`
      if (!posthogEnabled) {
        ph.opt_out_capturing()
        ph.set_config({
          capture_pageview: false,
          capture_pageleave: false,
          capture_heatmaps: false,
          capture_performance: false,
          autocapture: false,
          disable_session_recording: true,
          capture_exceptions: false,
        })
      } else {
        ph.opt_in_capturing()
        ph.set_config({
          capture_pageview: false,
          capture_pageleave: true,
          capture_heatmaps: true,
          capture_performance: true,
          capture_exceptions: true,
          autocapture: true,
        })
        console.warn(`PostHog enabled`)
      }
    },
  }
) as PostHog | undefined
